import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HideFloatingCartService {
  private _hide$ = new BehaviorSubject<boolean>(false);
  hide$ = this._hide$.asObservable();

  setHide(hide: boolean) {
    this._hide$.next(hide);
  }
}
